module.exports = __webpack_public_path__ + "media/images/favicon/secondary/android-icon-36x36-401bb256c55119d8fd2d1e1e91a5cfc5.png";